import {inject, Injectable} from '@angular/core';
import {SessionStore} from '../stores/session.store';
import {UserProfileService} from './user-profile.service';
import {TokenStorageService} from './token-storage.service';
import {TokenRefreshService} from './token-refresh.service';

@Injectable({ providedIn: 'root' })
export class AuthInitializerService {

	private session = inject(SessionStore);
	private profile = inject(UserProfileService);
	private storage = inject(TokenStorageService);
	private tokenRefresh = inject(TokenRefreshService);

	init(): void {

		const tokens = this.storage.get();
		if (!tokens?.jwt) return;

		try {

			const decoded = this.session.startSession(tokens.jwt);
			this.tokenRefresh.scheduleFromToken(tokens.jwt);

			if (!decoded?.sub) {
				this.storage.clear();
				return;
			}

			this.profile.setProfile(decoded.sub);

		} catch {
			this.storage.clear();
		}
	}
}
